import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import college from "../config/collegeConfig";
import { apiJson } from "../utils/api";
import { useT, LanguageToggle } from "../i18n/LanguageContext";

const AdminLogin = () => {
  const { t } = useT();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const data = await apiJson("/api/admin/login", {
        method: "POST",
        body: JSON.stringify({ username, password }),
      });

      localStorage.setItem("token", data.token);
      localStorage.setItem("admin", JSON.stringify(data.admin));
      localStorage.setItem("permissions", JSON.stringify(data.admin.permissions));
      navigate("/admin");
    } catch (err) {
      setMessage(err.message || "Login error. Please try again.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center px-4 relative">
      <div className="absolute top-4 right-4"><LanguageToggle /></div>
      <div className="text-center mb-8">
        {college.logo && (
          <img
            src={college.logo}
            alt="College Logo"
            className="mx-auto mb-2 w-20 h-20 object-contain"
          />
        )}
        <h1 className="text-xl sm:text-2xl font-bold text-gray-800">
          {college.name}
        </h1>
        <p className="text-sm text-gray-500">{college.tagline}</p>
      </div>

      <div className="w-full max-w-md bg-white shadow-md rounded-lg p-6">
        <h2 className="text-lg font-semibold text-gray-700 text-center mb-4">
          {t("auth.adminLogin")}
        </h2>
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              {t("auth.username")}
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring focus:ring-indigo-200"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              {t("auth.password")}
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring focus:ring-indigo-200"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-indigo-600 text-white py-2 rounded-md hover:bg-indigo-700 transition"
          >
            {t("common.login")}
          </button>
        </form>

        {message && (
          <p className="text-red-600 text-sm mt-4 text-center">{message}</p>
        )}
      </div>
    </div>
  );
};

export default AdminLogin;
